import { discardLocalSession } from './authentication';
import * as honeybadger from './honeybadger';
import { onUserSignOut } from './user-events';

export type ServiceResult = { ok: boolean; message?: string };

export type ServiceDispatchAction = () => Promise<ServiceResult>;

// Wraps a service call and converts failures into a { ok, message } result,
// with the same Honeybadger + revoked-session handling the legacy redux
// serviceDispatch helper applied.
export const serviceDispatch = async (
  action: ServiceDispatchAction
): Promise<{ ok: boolean; message?: string }> => {
  try {
    const response = await action();
    return response;
  } catch (error) {
    console.error(error);

    honeybadger.notify(error, 'serviceDispatch');

    let errorMessage = error instanceof Error ? error.message : 'Unknown Error';

    if (errorMessage.endsWith('Access denied')) {
      discardLocalSession();
      onUserSignOut();
      window.location.reload();
    }

    return {
      ok: false,
      message: errorMessage,
    };
  }
};
